import Link from "next/link";
import { FC, Fragment, ReactNode } from "react";
import styles from "./Breadcrumb.module.scss";
import Text from "../Text";
import classNames from "classnames";
import { isUsingLayoutV2 } from "~/utils/theme";

export interface BreadcrumbItem {
  title: string;
  path?: string;
  icon?: ReactNode;
}

interface BreadcrumbProps {
  items?: BreadcrumbItem[];
  className?: string;
}

const Breadcrumb: FC<BreadcrumbProps> = ({ items, className }) => {
  return (
    <div
      className={classNames(styles.breadcrumb, className, "overflow-hidden")}
    >
      {items?.map((item, index) => (
        <Fragment key={item.title}>
          {!item.path ? (
            <>
              {item?.icon}
              <Text
                type={"body-2"}
                className={classNames({
                  ["font-semibold whitespace-nowrap overflow-hidden text-ellipsis"]: true,
                  "!text-base": isUsingLayoutV2,
                })}
              >
                {item.title}
              </Text>
            </>
          ) : (
            <a href={item.path} className={styles.breadcrumb_item}>
              {item?.icon}
              <Text
                className={classNames({
                  ["font-semibold"]: true,
                  "!text-base": isUsingLayoutV2,
                })}
                type={"body-2"}
              >
                {item.title}
              </Text>
            </a>
          )}

          {index < items.length - 1 && <Text type="body-2"> / </Text>}
        </Fragment>
      ))}
    </div>
  );
};

export default Breadcrumb;
